<template>
    <v-container>    
        <v-card width="400">
            <v-card-title class="text-h5 text-center"><h1 class="text-h5 font-weight-regular">Authenticator app MFA</h1></v-card-title>
    
            <v-list-item three-line>
                  <v-avatar>
      <v-icon class="pa-2 flex-item"
                        right
                        >
                        mdi-cellphone-information
                        </v-icon>
    </v-avatar>
                        <v-card-text>To complete sign-in, enter the code from your authenticator app.</v-card-text>
            </v-list-item>

            <v-card-title>Code</v-card-title>

            <v-container max-width="400">
                <v-text-field outlined rounded aria-label="challengeResponses" v-model="challengeResponses" label="challengeResponses" required></v-text-field>
            
                <v-btn outlined rounded block @click="handleAnswerChallenge">sign in</v-btn>
            </v-container>
            <v-container max-width="400">
                <v-btn outlined rounded block pt-5 @click="logout">Go Back</v-btn>
            </v-container>
            <v-alert v-show="errorMessage" type="error">{{errorMessage}}</v-alert>
        </v-card>
    </v-container>  
    <!-- <v-container>
        <v-card width="400">
            <v-card-title class="text-h5 text-center">If you loss your device...</v-card-title>
            <v-btn outlined rounded block pt-5 @click="logout">Forget about this device</v-btn>
        </v-card>
    </v-container> -->
</template>


<script setup>
    import {reactive, ref} from 'vue'
    import { useUserStore } from '@/store/user'
    import { usePathController } from '@/composables/usePathController'
    import {useLogger} from "@/composables/useLogger"
    import {useEntityRoute} from '@/composables/route/useListViewRoute'
    const {sendLog} = useLogger() 
    const { goTo, logoutCoordinator, followRedirection } = usePathController()
    const queryValue = useEntityRoute()
    const userStore = useUserStore()
    const challengeResponses = ref("")
    const errorMessage = ref("")
    const handleAnswerChallenge = async () => {
        try{
            const USER_ID_FOR_SRP = queryValue?.USER_ID_FOR_SRP?.value || userStore.challengeMetadataBody?.USER_ID_FOR_SRP
            const challengeName = queryValue?.challengeName?.value || userStore.challengeMetadataBody?.challengeName
            const session = queryValue?.session?.value || userStore.challengeMetadataBody?.session
            
            sendLog("debug", "handle_cognito_challenge", {USER_ID_FOR_SRP, challengeName, session})

            const payload = { 
                challengeResponses: challengeResponses.value, 
                USER_ID_FOR_SRP: USER_ID_FOR_SRP, 
                challengeName: challengeName, 
                session: session,
                redirectSubsystem: queryValue?.redirectSubsystem?.value,
                landingPath: queryValue?.landingPath?.value,
            }
            const response = await userStore.answerChallenge(payload)
            followRedirection(response)
        }catch(error){
            sendLog("error", "handle_answer_challenge", {event: "challenge_failed", error})
            errorMessage.value = error?.message
            if(error.response && error.response.data && error.response.data.retryable){
            errorMessage.value = "Code is incorrect, please try again."
            }
            goTo("/login", {"errorMessage": errorMessage.value} )
        }
    }
   const logout = async () => {
    logoutCoordinator()
    goTo("/login")
  } 
</script>